import { apiCall } from "./Interceptor";

const GET_LOGS_LIST = "/logs";
const DOWNLOAD_LOGS = "/logs";

const getLogsList = async (userId) => {
    const response = await apiCall.get(`${GET_LOGS_LIST}?userId=${userId}`);
    return response;
}
const downloadLogsList = async (data,userId) => {
    const response = await apiCall.post(`${DOWNLOAD_LOGS}${userId ? `?userId=${userId}` : ''}`, data);
    return response;
}

export default {
    getLogsList,
    downloadLogsList,
};
